var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.881,
    height: 32.975,
    viewBox: "0 0 13.881 32.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -2.475)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.94,20.5A6.961,6.961,0,0,0,30,27.44v6.593a6.94,6.94,0,0,0,13.881,0V27.44A6.961,6.961,0,0,0,36.94,20.5ZM41.9,34.034a4.962,4.962,0,0,1-9.925,0V27.44a4.962,4.962,0,0,1,9.925,0Z",
    transform: "translate(0 -11.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.172,32.4a.97.97,0,0,0-.972.972v2.672a.97.97,0,0,0,.972.972.993.993,0,0,0,.972-.972V33.372A.97.97,0,0,0,48.172,32.4Z",
    transform: "translate(-11.231 -19.541)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.35,85.261l-1.7,1.7-1.7-1.7a.982.982,0,0,0-1.388,1.388l2.394,2.394a.94.94,0,0,0,.694.278,1.032,1.032,0,0,0,.694-.278l2.394-2.394a.982.982,0,0,0-1.388-1.388Z",
    transform: "translate(-6.709 -53.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.949,6.544l1.7-1.7,1.7,1.7a.94.94,0,0,0,.694.278,1.032,1.032,0,0,0,.694-.278.984.984,0,0,0,0-1.388L44.344,2.761a.984.984,0,0,0-1.388,0L40.561,5.156a.982.982,0,0,0,1.388,1.388Z",
    transform: "translate(-6.709)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDropdown);
export default __webpack_public_path__ + "static/media/menu-dropdown.233255da283544631cd6c5d5022b64e2.svg";
export { ForwardRef as ReactComponent };